export default __webpack_public_path__ + "static/media/sqm.67d6dede.png";